import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Typography } from '@mui/material';
import { useSessionstorageState } from 'rooks';
import {isMobile} from "../utils/deviceUtils"

const BetaDisclaimer = (props) => {
  
  const [hidden, setHidden] = useSessionstorageState('excelsior:beta-disclaimer-shown-bool', false);

  if (hidden) return null;


  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        zIndex: 9999,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box 
        position="absolute" 
        bottom={0} 
        left={0} 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        marginLeft={0.2}
        sx={{ opacity: 0.5 }}
      >
        <Typography 
          variant="caption" 
          sx={{
              backgroundColor: "rgba(0, 0, 0, 0.5)", 
              opacity:1,
              textShadow: "0px 0px 2px rgba(0, 0, 0, 1)",
              pointerEvents: 'none',
              zIndex:99999,
          }}
        >
          BETA v{process.env.REACT_APP_VERSION + " "} 
        </Typography>
        {/* {props?.perma === 'book' && */}
        <Typography fontSize={isMobile() ? '1rem' : '.8rem'}>
        &nbsp;[<CloseIcon 
          onClick={() => setHidden(true)} 
          style={{ 
            cursor: 'pointer', 
            ...(isMobile() ? { fontSize: '1rem' } : { fontSize: '.8rem' })
          }} 
        />]
        </Typography>
        {/* } */}
      </Box>
    </div>
  );
};

export default BetaDisclaimer;